import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default class CardAdminLocationExternalIdentifiers extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.location &&
              this.props.location.brightreeExternalBranchOfficeId
                ? this.props.location.brightreeExternalBranchOfficeId
                : ""
            }
            size="small"
            label="Brightree Branch Office ID"
            variant="standard"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => {
              if (e.target.value.trim() === "") {
                // If the input is an empty string, set it to null
                this.props.onChange({ brightreeExternalBranchOfficeId: null });
              } else if (!isNaN(e.target.value.trim())) {
                // If it's a valid number, parse it as an integer
                this.props.onChange({
                  brightreeExternalBranchOfficeId: parseInt(
                    e.target.value.trim(),
                  ),
                });
              } else {
                // If it's invalid input (non-numeric), keep the value as-is (text)
                this.props.onChange({
                  brightreeExternalBranchOfficeId: e.target.value.trim(),
                });
              }
            }}
            onChange={(e) =>
              this.props.onChange({
                brightreeExternalBranchOfficeId: e.target.value,
              })
            }
            error={
              !!this.props.validationIssues.brightreeExternalBranchOfficeId
            }
            helperText={
              this.props.validationIssues.brightreeExternalBranchOfficeId
                ? this.props.validationIssues.brightreeExternalBranchOfficeId
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.location &&
              this.props.location.brightreeExternalInventoryLocationId
                ? this.props.location.brightreeExternalInventoryLocationId
                : ""
            }
            size="small"
            label="Brightree Inventory Location ID"
            variant="standard"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => {
              if (e.target.value.trim() === "") {
                // If the input is an empty string, set it to null
                this.props.onChange({
                  brightreeExternalInventoryLocationId: null,
                });
              } else if (!isNaN(e.target.value.trim())) {
                // If it's a valid number, parse it as an integer
                this.props.onChange({
                  brightreeExternalInventoryLocationId: parseInt(
                    e.target.value.trim(),
                  ),
                });
              } else {
                // If it's invalid input (non-numeric), keep the value as-is (text)
                this.props.onChange({
                  brightreeExternalInventoryLocationId: e.target.value.trim(),
                });
              }
            }}
            onChange={(e) =>
              this.props.onChange({
                brightreeExternalInventoryLocationId: e.target.value,
              })
            }
            error={
              !!this.props.validationIssues.brightreeExternalInventoryLocationId
            }
            helperText={
              this.props.validationIssues.brightreeExternalInventoryLocationId
                ? this.props.validationIssues
                    .brightreeExternalInventoryLocationId
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={
              this.props.location && this.props.location.birdeyeExternalId
                ? this.props.location.birdeyeExternalId
                : ""
            }
            size="small"
            label="Birdeye ID"
            variant="standard"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => {
              if (e.target.value.trim() === "") {
                // If the input is an empty string, set it to null
                this.props.onChange({ birdeyeExternalId: null });
              } else if (!isNaN(e.target.value.trim())) {
                // If it's a valid number, parse it as an integer
                this.props.onChange({
                  birdeyeExternalId: parseInt(e.target.value.trim()),
                });
              } else {
                // If it's invalid input (non-numeric), keep the value as-is (text)
                this.props.onChange({
                  birdeyeExternalId: e.target.value.trim(),
                });
              }
            }}
            onChange={(e) =>
              this.props.onChange({ birdeyeExternalId: e.target.value })
            }
            error={!!this.props.validationIssues.birdeyeExternalId}
            helperText={
              this.props.validationIssues.birdeyeExternalId
                ? this.props.validationIssues.birdeyeExternalId
                : ""
            }
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "External Identifiers";
  }
}
